import type { KdfParams } from "@envstash/protocol";
import type { ArgonRequest, ArgonResponse } from "../workers/argon.worker.js";

let worker: Worker | null = null;
let nextId = 1;
const pending = new Map<
  number,
  { resolve: (v: { wrapKey: Uint8Array; authKey: Uint8Array }) => void; reject: (e: Error) => void }
>();

function getWorker(): Worker {
  if (worker) return worker;
  worker = new Worker(new URL("../workers/argon.worker.ts", import.meta.url), { type: "module" });
  worker.onmessage = (ev: MessageEvent<ArgonResponse>) => {
    const p = pending.get(ev.data.id);
    if (!p) return;
    pending.delete(ev.data.id);
    if (ev.data.ok) p.resolve({ wrapKey: ev.data.wrapKey, authKey: ev.data.authKey });
    else p.reject(new Error(ev.data.error));
  };
  worker.onerror = (ev) => {
    for (const p of pending.values()) p.reject(new Error(ev.message || "key derivation worker failed"));
    pending.clear();
    worker = null;
  };
  return worker;
}

/** Argon2id + HKDF off the main thread (~1s at the default 64 MiB / t=3). */
export function derivePasswordKeysAsync(
  password: string,
  kdf: KdfParams,
): Promise<{ wrapKey: Uint8Array; authKey: Uint8Array }> {
  return new Promise((resolve, reject) => {
    const id = nextId++;
    pending.set(id, { resolve, reject });
    const req: ArgonRequest = { id, password, kdf };
    getWorker().postMessage(req);
  });
}
